// views/newProject/_importProject.js
// An import of existing project window

import app from '../../app';
import _ from '../../libs/lodash';
import importProjectFormView from './importProject';
import closeIcon from '../../svg/close_black.svg';
import routerHelper from '../../helpers/router';
import common from './common';

import importProjectIcon from '../../svg/projects_icons/import_project.svg';
import backIcon from '../../svg/projects_icons/back.svg';

const {
  helpers: { adjustPopupPosition },
  views: {
    spaceFillerView, headerTitleView, projectHelpView, headerCloseBtnView, headerBackBtnView,
  },
  templates: { headerTitle, headerCloseBtn, headerBackBtn },
  uiHandlers: { onCloseBtnClick, onBackBtnClick },
  ids: { ID_VIEW_POPUP_HEADER, ID_VIEW_FORM_WINDOW },
} = common;

const ID_VIEW_IMPORT_PROJ_WINDOW = 'importProjectLayout';
const ID_FEATURE_IMPORTPROJ = 'importProjectBlock';

const webixUI = {
  view: 'window',
  id: ID_VIEW_IMPORT_PROJ_WINDOW,
  css: 'create_project_layout',
  borderless: true,
  // header: false,
  head: false,
  modal: false,
  move: false,
  hidden: true,
  // unClosable: true,
  position(state) {
    adjustPopupPosition.apply(this, [state]);
  },
  body: {
    rows: [{
      id: ID_VIEW_POPUP_HEADER,
      css: 'create_project_layout_header topHeaderShadow',
      height: 54,
      paddingY: 12,
      cols: [
        // headerBackBtnView(headerBackBtn, {
        //     icon: backIcon,
        //     value: __('back_btn')
        // }, onBackBtnClick),
        spaceFillerView(9),
        headerTitleView(headerTitle, {
          infoIcon: importProjectIcon,
          value: __('import_new_project'),
        }),
        projectHelpView(ID_FEATURE_IMPORTPROJ),
        { width: 6 },
        headerCloseBtnView(headerCloseBtn, {
          icon: closeIcon,
        }, onBackBtnClick),
        { width: 9 },
      ],
    }, {
      view: 'scrollview',
      autoheight: true,
      scroll: 'y',
      borderless: true,
      body: {
        rows: [{
          height: 20,
        }, {
          id: ID_VIEW_FORM_WINDOW,
          css: 'create_project_form',
          rows: [],
        }],
      },
    }],
  },
  on: {
    onHide: onPopupHide,
    onShow: onPopupShow,
  },
};

// global events
const _events = {
  'body:resize': {
    fn: data => {
      console.info('[importproject] -> onBodyResize'); // !DEBUG
      $$(ID_VIEW_IMPORT_PROJ_WINDOW) && $$(ID_VIEW_IMPORT_PROJ_WINDOW).resize();
    },
  },
  'leftSideBar:changedMode': {
    fn: () => {
      console.info('[importproject] -> onChangedSideBarMode'); // !DEBUG
      $$(ID_VIEW_IMPORT_PROJ_WINDOW) && $$(ID_VIEW_IMPORT_PROJ_WINDOW).resize();
    },
  },
  'tab:projectCreate': {
    fn: () => {
      console.info('[importproject] -> onTabProjectCreate'); // !DEBUG
      // routerHelper.pushRoute({ name: 'app' });
    },
  },
};

function onPopupHide() {
  Object.keys(_events).forEach(event => {
    app.off(_events[event].id);
  });
}

function onPopupShow() {
  Object.keys(_events).forEach(event => {
    _events[event].id = app.on(event, _events[event].fn);
  });
}

function init() {
  $$(ID_VIEW_FORM_WINDOW).addView(
    _.isFunction(importProjectFormView.view)
      ? importProjectFormView.view()
      : importProjectFormView.view,
  );

  importProjectFormView.init();

  $$(ID_VIEW_IMPORT_PROJ_WINDOW).show();
}

function cleanup() {
  $$(ID_VIEW_POPUP_HEADER).removeView(`${ID_FEATURE_IMPORTPROJ}View`);
  $$(ID_VIEW_IMPORT_PROJ_WINDOW).hide();
}

export {
  webixUI,
  init,
  cleanup,
};
